// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartLineQuantityStyles } from "@west/Overrides/Widgets/Cart/CartLineQuantity";
import { hideElement, xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

cartLineQuantityStyles.editableQuantityTextField = {
    labelProps: {
        css: css`
            ${xScreen("gt", "lg")} {
                ${hideElement}
            }
        `,
    },
};

cartLineQuantityStyles.alertTooltip = {
    cssOverrides: {
        tooltipWrapper: css`
            margin-left: 7px;
        `,
    },
};

cartLineQuantityStyles.alertIcon = {
    size: 16,
    color: "warning",
};
